import { useFliptBoolean } from "@flipt-io/flipt-client-react";
import yn from "yn";
import useUser from "~/contexts/user";

const { VITE_AI_SKILLS_ENABLED } = import.meta.env;

/**
 * Feature flag hook for AI Skills functionality.
 *
 * Controls whether users see:
 * - RichTextInput with /skill blocks (enabled) vs plain textarea (disabled)
 * - SkillSelector dropdown (enabled) vs hidden (disabled)
 * - SkillAutocomplete popup (enabled) vs hidden (disabled)
 *
 * Requires both:
 * - VITE_AI_SKILLS_ENABLED environment variable must be true
 * - Flipt feature flag "agent-skills" must be enabled for the user
 *
 * @returns true if skills feature is enabled for the current user, false otherwise
 */
export function useSkillsFeature(): boolean {
  const user = useUser();
  const flagEnabled = useFliptBoolean("agent-skills", false, user?.email);

  if (!yn(VITE_AI_SKILLS_ENABLED, { default: false })) {
    return false;
  }

  return flagEnabled;
}
